export const GridValueNormlizer = (StateBank) => {
  const MedicalFormattedValues = StateBank?.GroupElements?.map(
    (GroupElement) => {
      if (
        GroupElement?.ElsRecord?.Type === "ComboBox" ||
        GroupElement?.ElsRecord?.Type === "RadCheckedDropDownList"
      ) {
        return {
          base64: "",
          idcommand: "",
          iddetail: GroupElement?.IdColumn,
          element: GroupElement,
          value: "",
          ListDefaultAnswer: GroupElement?.ElsRecord?.ListDefaultAnswer,
          name: GroupElement?.ElsRecord.Name,
        };
      } else {
        return {
          base64: "",
          ...(GroupElement?.Id
            ? { iddetail: GroupElement?.Id }
            : { HeaderColumn: GroupElement?.NameColumn }),
          element: GroupElement,
          value: "",
          name: GroupElement?.ElsRecord.Name,
        };
      }
    }
  );
  return (
    MedicalFormattedValues?.sort((a, b) => {
      return a.iddetail - b.iddetail;
    }) ?? []
  );
};
